// extracted by mini-css-extract-plugin
export default {"middleTric":"Clients_middleTric__h9Hx3","ClientLogos":"Clients_ClientLogos__NJPGS"};